import { render, staticRenderFns } from "./DocumentFilter.vue?vue&type=template&id=b1ebdc9e&scoped=true&"
import script from "./DocumentFilter.vue?vue&type=script&lang=js&"
export * from "./DocumentFilter.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFilter.vue?vue&type=style&index=0&id=b1ebdc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ebdc9e",
  null
  
)

export default component.exports